import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import FloatingWhatsApp from './FloatingWhatsApp';

const PageLoader = () => (
  <div className="w-full h-screen flex items-center justify-center bg-spring-bg text-spring-text">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 416 150"
      className="w-12 h-auto animate-[spin_2s_linear_infinite]"
      fill="currentColor"
    >
      <path d="M415.99 2.77 315.33 148.76c-.49.71-1.43.96-2.21.6L.61 2.02C-.42 1.54-.07 0 1.06 0h413.47c1.42 0 2.26 1.6 1.45 2.77Z" />
    </svg>
  </div>
);

export default function Layout() {
  return (
    <div className="flex flex-col min-h-screen relative">
      <Header />
      <main className="flex-grow w-full">
        <React.Suspense fallback={<PageLoader />}>
          <Outlet />
        </React.Suspense>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
